function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';

/**
 * 列表
 * @param pram
 * @constructor
 */
export function ListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = pram || {},
    companyId = _ref.companyId,
    name = _ref.name,
    page = _ref.page,
    limit = _ref.limit;
  var data = {
    companyId: companyId,
    name: name,
    page: page,
    limit: limit
  };
  return request({
    url: '/admin/store/product/combo/list',
    method: 'GET',
    params: data
  });
}
var handerSubmit = function handerSubmit() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = _objectSpread({}, data) || {},
    companyId = _ref2.companyId,
    name = _ref2.name,
    price = _ref2.price,
    remark = _ref2.remark,
    status = _ref2.status,
    _ref2$comboInfoList = _ref2.comboInfoList,
    comboInfoList = _ref2$comboInfoList === void 0 ? [] : _ref2$comboInfoList,
    image = _ref2.image,
    jumpUrl = _ref2.jumpUrl;
  return {
    companyId: companyId,
    name: name,
    price: price,
    remark: remark,
    status: status,
    comboInfoList: comboInfoList,
    image: image,
    jumpUrl: jumpUrl
  };
};

/**
 * 新增
 * @param pram
 * @constructor
 */
export function AddArticle(data) {
  return request({
    url: '/admin/store/product/combo/save',
    method: 'post',
    data: handerSubmit(data)
  });
}

/**
 * 更新
 * @param pram
 * @constructor
 */
export function UpdateArticle(data) {
  return request({
    url: '/admin/store/product/combo/update',
    method: 'post',
    data: _objectSpread(_objectSpread({}, handerSubmit(data)), {}, {
      id: data.id
    })
  });
}

/**
 * 删除
 * @param ids
 * @constructor
 */
export function DelArticle(id) {
  return request({
    url: '/admin/store/product/combo/delete',
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 详情
 * @param id
 * @constructor
 */
export function getComDetail(id) {
  return request({
    url: '/admin/store/product/combo/info',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 修改状态
 * @param {*} data 
 * @returns 
 */
export function changeState(id) {
  return request({
    url: '/admin/store/product/combo/updateStatus',
    method: 'get',
    params: {
      id: id
    }
  });
}